module.exports = __webpack_public_path__ + "static/media/joah_hero.7e991499.jpg";